import { DashboardPieChart } from "@aidkitorg/types/lib/admin-panel/dashboard";
import React, { useEffect, useState } from "react";
import { generateDistroSummaryKind } from "../../../utils/adminPanel.utils";

export const usePieChartFormState = (component?: DashboardPieChart) => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  
  const [groupDataField, setGroupDataField] = useState('')
  const [aggregation, setAggregation] = useState('Count')
  const [dataField, setDataField] = useState('')

  useEffect(() => {
    if (!component) return

    const componentTitle = 'title' in component && component.title
      ? typeof component.title === 'string'
        ? component.title
        : component.title['en']
      : 'Dashboard Component';
    setTitle(componentTitle)
    setDescription(component.description || '')
    setAggregation(component.summary.kind)

    if (component.summary.kind === 'Sum' || component.summary.kind === 'Mean') {
      if (component.summary.value.kind === 'Field') {
        setDataField(component.summary.value.field)
      }
    }

    const groups = component.groups
    if (groups.length === 1 && groups[0].kind === 'Field') {
      setGroupDataField(groups[0].field)
    }
  }, [component])

  const buildPieChartObject = (): DashboardPieChart => {
    const pieChart: DashboardPieChart = {
      kind: 'Pie Chart',
      title: title,
      description: description,
      summary: generateDistroSummaryKind(aggregation,dataField),
      groups: [{
        kind: 'Field',
        field: groupDataField
      }],
    }

    return pieChart
  }
  const isFormStateValid = title !== '' &&
    groupDataField !== '' &&
    (aggregation === 'Count' || dataField !== '')

  return {
    title, setTitle,
    description, setDescription,
    groupDataField, setGroupDataField,
    aggregation, setAggregation,
    dataField, setDataField,
    buildPieChartObject,
    isFormStateValid
  }
}